import { Box, Typography, Link } from "@mui/material";
import logo from "./logo.png";
import { useEffect } from "react";

export default function SuccessScreen() {


    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                minHeight="100%"
                sx={{
                    p: 4,
                    boxSizing: 'border-box',
                    textAlign: 'center',
                }}
            >
                <Typography variant="h6" component="h3" gutterBottom>
                    Thank You! Your Submission Has Been Received!
                </Typography>
            </Box>
        </>
    );
}
